angular.module('impactx.search').controller('SupplierItemActionCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'RFXCreateService',
    'ProductViewService',
    SupplierItemActionCtrl]);

function SupplierItemActionCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, RFXCreateService, ProductViewService) {
    var self = this;

    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        createRFX: TranslationService.get('createRFX'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.$onInit = function () {
        self.hasActions = self.supplier.canAddToThemeWorld || self.supplier.canAddToProductView || self.supplier.canRemoveFromThemeWorld || self.supplier.showRFXButton
            || self.supplier.canRemoveFromProductView;
    };

    self.addToThemeWorld = function($event) {
        self.supplier.canAddToThemeWorld = false;
        self.supplier.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addSuppliersToThemeWorld([self.supplier]);
    };

    self.removeFromThemeWorld = function($event) {
        var suppierIds = [];
        self.supplier.canAddToThemeWorld = true;
        self.supplier.canRemoveFromThemeWorld = false;
        suppierIds.push(self.supplier.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeSuppliersFromThemeWorld($context.hasActiveThemeWorld.id, suppierIds);
    };

    self.addToProductView = function($event) {
        self.supplier.canAddToProductView = false;
        self.supplier.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addSuppliersToProductView([self.supplier]);
    };

    self.removeFromProductView = function($event) {
        var suppierIds = [];
        self.supplier.canAddToProductView = true;
        self.supplier.canRemoveFromProductView = false;
        suppierIds.push(self.supplier.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeSuppliersFromProductView($context.hasActiveProductView.id, suppierIds);
    };

    self.createRFX = function(){
        RFXCreateService.createRFX("supplier", self.supplier.id);
    };
}